var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "mb-5": !_vm.isNew } },
    [
      _c(
        "b-row",
        { staticClass: "mb-4" },
        [
          _c(
            "b-col",
            { staticClass: "pb-1", attrs: { lg: "3", md: "6" } },
            [
              _vm.isNew
                ? _c("material-input", {
                    staticClass: "form-group-material-no-label",
                    attrs: {
                      id: "segment-edit",
                      value: _vm.currentSegment.name,
                      "custom-expression": "currentSegment.name",
                      placeholder: _vm.$t("lists.placeholders.segmentName"),
                    },
                    on: { change: _vm.handleChangeName },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "segment-edit" } },
                [_vm._v(_vm._s(_vm.$t("global.words.segmentEdit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("lists.segments.contactsMatch")) + "\n    "
        ),
        _c(
          "button",
          {
            staticClass:
              "mr-2 ml-2 bold btn-white btn-sm dropdown-toggle clickable dropdown-condition text-lowercase",
            attrs: {
              id: "dropdown-condition",
              role: "button",
              "data-value": "or",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false",
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.getCurrentJoinText) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown-menu",
            attrs: {
              "aria-labelledby": "dropdown-condition",
              "x-placement": "bottom-start",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "dropdown-item other-condition",
                on: { click: _vm.handleToggleJoin },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.getAlternateJoinText) + "\n      "
                ),
              ]
            ),
          ]
        ),
        _vm._v(
          "\n    " + _vm._s(_vm.$t("lists.segments.ofTheFollowing")) + ":\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.currentSegment.conditions, function (condition, index) {
          return _c(
            "div",
            { key: index },
            [
              _c("segments-condition", {
                attrs: {
                  index: index,
                  segments: _vm.segments,
                  condition: condition,
                  "can-delete": _vm.canDeleteCondition,
                  $v: _vm.$v,
                },
                on: {
                  change: function ($event) {
                    return _vm.handleUpdateCondition($event, index)
                  },
                  delete: function ($event) {
                    return _vm.handleDeleteCondition(index)
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "justify-content-between align-items-center mt-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", sm: "5", lg: "3" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "clickable text-primary bold bs-0 px-0",
                  attrs: { variant: "transparent" },
                  on: { click: _vm.handleAddSegment },
                },
                [
                  _vm._v(
                    "\n        + " +
                      _vm._s(_vm.$t("lists.segments.addAnotherCondition")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "simple-button",
                {
                  key: _vm.newSegmentCreated,
                  attrs: {
                    disabled: !_vm.isValid,
                    "class-name": "create-segment",
                    loading: _vm.createSegmentLoadingLocal,
                  },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("\n        " + _vm._s(_vm.saveButtonText) + "\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }